var _line, _polyline, _polyline2, _line2, _polyline3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlphabeticalOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.744,
    y1: 17.315,
    x2: 16.744,
    y2: 6.54
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "20.382 14.949 16.781 18.55 13.17 14.94"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "3.62 11.076 6.202 4.711 8.706 11.076"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.267,
    y1: 9.481,
    x2: 8.079,
    y2: 9.481
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "3.62 14.201 8.706 14.201 3.618 19.289 8.684 19.289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabeticalOrder);
export default __webpack_public_path__ + "static/media/alphabetical-order.5b47b64b6a9d4fccd09512148a23eddb.svg";
export { ForwardRef as ReactComponent };